module.exports = __webpack_public_path__ + "img/s00164.c670aa53.jpg";